import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/cancel-subscription'

import { withCms, withLayout } from '../cms'

import '@grandvisionhq/fun-cancel-subscription/dist/index.css'

const CancelSubscriptionPage: NextPage = () => <Page />

export default compose(withCms(), withLayout())(CancelSubscriptionPage)
